export default {
  'page-title': 'System Creative Return Merchandise Authorization (RMA) - Creative Labs (Poland)    ',
  'page-desc': 'Check the status of your return request with your RMA number. ',
  'mode-of-contact': 'KONTAKT',
  'your-details': 'SZCZEGÓŁY',
  'rma-request': 'Wniosek RMA',
  'first-name': 'Imię',
  'last-name': 'Nazwisko',
  'enter-first-name': 'Proszę wpisać swoje imię.',
  'enter-last-name': 'Proszę wpisać swoje nazwisko.',
  'email-address': 'Adres e-mail',
  'enter-email': 'Wprowadź swój adres e-mail.',
  'enter-valid-email': 'Proszę wpisać aktualny adres e-mail.',
  'enter-pid': 'Please enter your personal ID',
  'super-x-fi': 'Super X-Fi',
  'products': 'Produkty',
  'sale': 'Sprzedaż',
  'help': 'Pomoc',
  'sign-in': 'Zaloguj się',
  'account': 'Konto',
  'loading-page': 'ŁADOWANIE...',
  'orders': 'Zamówienia',
  'membership-program': 'Program członkowski',
  'account-profile': 'Profil konta',
  'contact-us': 'Skontaktuj się z nami',
  'sign-out': 'Wyloguj się',
  'recent-orders': 'Ostatnie zamówienia',
  'view-all-orders': 'Zobacz wszystkie zamówienia',
  'email_registered': {
    'text1': 'adres e-mail został już zarejestrowany ',
    'link': 'Zaloguj się',
    'text2': ' aby odzyskać historię zamówień'
  },
  'country-region': 'Kraj / region',
  'select-country': 'Wybierz kraj',
  'preferred-language': 'Preferowany język odpowiedzi',
  'select-language': 'Proszę wybrać język',
  'next': 'Kolejny',
  'encountered-error': 'Napotkaliśmy błąd. Proszę spróbuj ponownie',
  'your-enquiry': 'ZGŁOSZENIE',
  'nature-enquiry': 'RODZAJ ZGŁOSZENIA',
  'order-number': 'Numer zamówienia',
  'order-id': 'ID zamówienia',
  'for-amazon-order': 'Dla zamówień ze sklepu Amazon',
  'enter-order-number': 'Proszę podać numer zamówienia',
  'rma-number': 'Numer RMA',
  'enter-rma-number': 'Wpisz swój numer RMA',
  'purchase_creative_com': {
    'text': 'Jeśli wadliwy produkt został zakupiony w sklepie Creative.com ',
    'link': 'poproś o wymianę tutaj'
  },
  'not-purchase-creative-com': '<p>Jeśli nie dokonałeś zakupu w sklepie internetowym Creative.com, skontaktuj się bezpośrednio ze sprzedawcą, aby uzyskać więcej informacji dotyczących zwrotu.</p><p><a href="https://pl.creative.com/help/warranty-returns" target="_blank">Kliknij tutaj, aby uzyskać więcej informacji dotyczących gwarancji i zwrotów.</a></p>',
  'not-purchase-creative-com-retailer-replacement': 'Jeśli nie dokonałeś zakupu w sklepie Creative.com, skontaktuj się bezpośrednio ze sprzedawcą w celu zgłoszenia reklamacji.',
  'not_purchase_creative_com_2': {
      'text': 'Jeśli wadliwy produkt nie został zakupiony bezpośrednio z Creative.com ',
      'link': 'poproś o wymianę tutaj'
  },
  'order-not-found': 'Wprowadzony numer zamówienia nie znajduje się w naszej bazie danych. Proszę podać poprawny numer zamówienia.',
  'rma-not-found': 'Wprowadzony numer RMA nie znajduje się w naszej dokumentacji. Wprowadź poprawny numer RMA.',
  'previous-order': 'Poprzednie zamówienie',
  'next-order': 'Następne zamówienie',
  'add-your-product': 'Dodaj swój produkt',
  'search-by-name': 'Wyszukaj według nazwy produktu',
  'select-product': 'Proszę wybrać produkt.',
  'upload-proof-update-date': {
    'text1': 'Proszę przedstawić dowód zakupu i datę zakupu. <br/>Jeśli nie masz dowodu zakupu,  ',
    'link': 'skontaktuj się z nami ',
    'text2': ' tutaj.'
  },
  'return-product': 'Zwrot produktu',
  'return-products': 'Zwrot produktu',
  'replace-defective-product': 'Wymień wadliwy produkt',
  'check-rma-status': 'Sprawdź status RMA',
  'service-request': 'Zgłoszenia serwisowe dostępne',
  'select-one-service': 'Wybierz z listy jeden rodzaj zgłoszenia. Jeśli masz więcej niż jedno zgłoszenie dla tego samego zamówienia, zgłoś je dla każdego z produktów oddzielnie. ',
  'select-one-servcie-2': 'Wybierz jedno zgłoszenie serwisowe.',
  'refund-products': 'Zwróć produkt',

  'qualifies-refund': 'Tylko {refundNotAvailable} kwalifikuje się do zwrotu w ramach gwarancji satysfakcji. <> Edytuj swoje produkty przed kontynuowaniem.',
  'replace-products': 'Wymień wadliwy produkt',
  'qualifies-replace': 'Tylko {repairNotAvailable} kwalifikuje się do wymiany. <> Edytuj swoje produkty przed kontynuowaniem.',
  'contact-us-assistance': 'Skontaktuj się z nami w celu uzyskania pomocy',
  'return-information': 'Informacje zwrotne',
  'replacement-information': 'Informacje o wymianie',
  'fill-in-all': 'Proszę wypełnić wszystkie pola w tej sekcji.',
  'message': 'Wiadomość',
  'enter-message': 'Proszę wprowadzić swoją wiadomość.',
  'submit': 'Wyślij',
  'submission-successful': 'Twoje zgłoszenie zostało przesłane.',
  'contact-us-thank-you': 'Odpowiemy w ciągu 2 dni roboczych.',
  'back-to-home': 'Wrócić do strony początkowej',
  'confirmation': 'Potwierdzenie',
  'rma-confirmation': 'Potwierdzenie RMA',
  'refresh-page': 'Odśwież',
  'loading': 'Ładowanie…..',
  'select': 'Wybierz adres',
  'selected': 'Wybrane',
  'update': 'Edytuj adres',
  'address': 'ADRES',
  'new-address': 'Nowy adres',
  'edit': 'Edytuj',
  'update-address': 'Zaktualizuj adres',
  'cancel': 'Anuluj',
  'back': 'Cofnij',
  'select-your-products': 'Wybierz swoje produkty',
  'serial-number': 'Numer seryjny',
  'returns-eligibility': 'Zwróć zakwalifikowane',
  'warranty': 'Gwarancja',
  'proof-purchase': 'Dowód zakupu',
  'purchase-date': 'Data zakupu',
  'select-date': 'Data zakupu',
  'how-find-serial-num': 'Jak znaleźć numer seryjny??',
  'yes': 'Tak',
  'no': 'Nie',
  'choose-file': 'Wybierz plik',
  'upload-supporting-file': 'Wczytaj zdjęcie',
  'remove': 'Usuń',
  'warranty-days-left': 'pozostało {warrantyDaysRemain} dni',
  'out-warranty': 'Poza gwarancją',
  'enter-serial': 'Wprowadź numer seryjny',
  'enter-serial-number': 'Wprowadź poprawny numer seryjny.',
  'serial-not-valid': 'Wprowadź poprawny numer seryjny.',
  'serial-num-submitted': 'Numer seryjny już przesłany, zmień na inny.',
  'file-formats-allowed': 'Dozwolone formaty plików: JPG, PNG, ZIP. Maksymalny rozmiar pliku: 4 MB.',
  'thank-you-rma-submit': 'Dziękujemy za przesłanie RMA.',
  'provide-rma-number': 'Jeśli chcesz skontaktować się z nami w sprawie tego zgłoszenia, prosimy o podanie swojego numeru RMA.   ',
  'retrieve_rma_status': {
    'text': 'Możesz uzyskać dostęp do zgłoszenia RMA lub wprowadzić zmiany w RMA, rejestrując ',
    'link': 'konto Creative'
  },
  'product-details': 'Szczegóły Produktu',
  'product': 'Produkt',
  'rma-details': 'Szczegóły RMA',
  'service-request2': 'Zgłoszenie serwisowe',
  'refund': 'Zwrot',
  'replacement': 'Zamiennik',
  'rma-status': 'Status RMA',
  'expires-date': 'Wygasa {date}',
  'refund-estimated-cost': 'Uwaga: kwota zwrotu jest obecnie wartością szacunkową i może ulec dalszej zmianie.',
  'service-fee': 'Opłata za usługę',
  'service-fee-text': 'Opłata za usługę może zostać naliczona, jeśli zwrócony produkt wykaże oznaki przypadkowego uszkodzenia lub używania. Skontaktujemy się z Tobą mailowo, jeśli będzie to miało zastosowanie. ',
  'product-is-defective': 'Produkt jest wadliwy',
  'repair-status-list': [
    {
      'status': 'Otrzymano zgłoszenie RMA',
      'desc': '<p>Twoje zgłoszenie RMA jest obecnie przetwarzane.</p><p><i>(Zwykle zajmuje to 1-2 dni robocze)</i></p>'
    },
    {
      status: 'Zatwierdzono zgłoszenie RMA',
      desc: `<p>Odeślij do nas swój produkt.  </p><p><i>(Zwykle zajmuje to 1-2 dni robocze)</i></p>
              <span style="font-weight: 500;">Wyświetl instrukcje dotyczące zwrotu</span>
              <div class="return-instruction">
                <div id="display_eu" style="display:{display_eu}">
                  Instrukcje dotyczące zwrotu produktu można znaleźć w wiadomości e-mail (Temat: Twoja prośba o zwrot produktu Creative Labs została zatwierdzona).
                  Możesz wygenerować etykietę dla przesyłki zwrotnej korzystając z poniższego linku i wprowadzeniu wymienionych informacji:
                  <p style="margin:10px auto">
                    URL: <a href="{courierLabelLink}" target="_blank">{courierLabelLink}</a> <br>
                    Numer zamówienia:  <span style='font-weight:500'>{orderNumber}</span> <br>
                    Kod zwrotu:   <span style='font-weight:500'>{b2cTrackingNumber}</span> <br>
                  </p>
                  <p>
                    Pamiętaj, że dostep do etykiety wysyłkowej jest jednorazowy, nie będzie możliwości ponownego wydrukowania.
                  </p>
                </div>

                <div id="display_others" style="display:{display_others}">
                  Instrukcje dotyczące zwrotu produktu można znaleźć w wiadomości e-mail (Temat: Twoja prośba o zwrot produktu Creative Labs została zatwierdzona).
                  <p id="display_shippingLabel1" style="margin:10px auto;{display_shippingLabel}">
                  Etykieta wysyłkowa musi zostać pobrana w ciągu 90 dni.
                  Po uzyskaniu dostępu do etykiety po raz pierwszy, należy ją pobrać lub wydrukować w ciągu 5 dni, po tym czasie etykieta nie będzie już dostępna.<br>
                      <a href="{courierLabelLink}" target="_blank" style="text-decoration:underline">Etykieta wysyłkowa</a>
                  </p>
                  <p id="display_shippingLabel2" style="margin:10px auto;{display_shippingLabel}">
                    Pamiętaj, że dostep do etykiety wysyłkowej jest jednorazowy, nie będzie możliwości ponownego wydrukowania.
                  </p>
                </div>
            </div>`
    },
    {
      status: 'Produkt otrzymany',
      desc: '<p>Weryfikujemy zwrócony produkt.</p><p><i>(Zwykle zajmuje to 1-2 dni robocze)</i></p>',
    },
    {
      status: 'Przygotowanie zamiennika',
      desc: '<p>Sprawdzamy dostępność zamiennika.</p><p><i>(Zwykle zajmuje to 1-2 dni robocze)</i></p>',
    },
    {
      status: 'Przygotowywanie Wysyłki',
      desc: '<p>Przygotowujemy zamiennik do wysyłki.</p><p><i>(Zwykle zajmuje to 1-2 dni robocze)</i></p>',
    },
    {
      status: 'Zamiennik Wysłany',
      desc: '<p>Zamiennik został wysłany.  <br />  </p>',
    }
  ],
  'refund-status-list': [
    {
      'status': 'Otrzymano zgłoszenie RMA',
      'desc': '<p>Twoje zgłoszenie RMA jest obecnie przetwarzane.</p><p><i>(Zwykle zajmuje to 1-2 dni robocze)</i></p>'
    },
    {
      status: 'Zatwierdzono zgłoszenie RMA',
      desc: `<p>Odeślij do nas swój produkt.  </p><p><i>(Zwykle zajmuje to 1-2 dni robocze)</i></p>
              <span style="font-weight: 500;">Wyświetl instrukcje dotyczące zwrotu</span>
              <div class="return-instruction">
                <div id="display_eu" style="display:{display_eu}">
                  Instrukcje dotyczące zwrotu produktu można znaleźć w wiadomości e-mail (Temat: Twoja prośba o zwrot produktu Creative Labs została zatwierdzona).
                  Możesz wygenerować etykietę dla przesyłki zwrotnej korzystając z poniższego linku i wprowadzeniu wymienionych informacji:
                  <p style="margin:10px auto">
                    URL: <a href="{courierLabelLink}" target="_blank">{courierLabelLink}</a> <br>
                    Numer zamówienia:  <span style='font-weight:500'>{orderNumber}</span> <br>
                    Kod zwrotu:   <span style='font-weight:500'>{b2cTrackingNumber}</span> <br>
                  </p>
                  <p>
                    Pamiętaj, że dostep do etykiety wysyłkowej jest jednorazowy, nie będzie możliwości ponownego wydrukowania.
                  </p>
                </div>

                <div id="display_others" style="display:{display_others}">
                  Instrukcje dotyczące zwrotu produktu można znaleźć w wiadomości e-mail (Temat: Twoja prośba o zwrot produktu Creative Labs została zatwierdzona).
                  <p id="display_shippingLabel1" style="margin:10px auto;{display_shippingLabel}">
                  Etykieta wysyłkowa musi zostać pobrana w ciągu 90 dni.
                  Po uzyskaniu dostępu do etykiety po raz pierwszy, należy ją pobrać lub wydrukować w ciągu 5 dni, po tym czasie etykieta nie będzie już dostępna.<br>
                      <a href="{courierLabelLink}" target="_blank" style="text-decoration:underline">Etykieta wysyłkowa</a>
                  </p>
                  <p id="display_shippingLabel2" style="margin:10px auto;{display_shippingLabel}">
                    Pamiętaj, że dostep do etykiety wysyłkowej jest jednorazowy, nie będzie możliwości ponownego wydrukowania.
                  </p>
                </div>
            </div>`
    },
    {
      status: "Produkt otrzymany",
      desc: "<p>Weryfikujemy zwrócony produkt.</p><p><i>(Zwykle zajmuje to 1-2 dni robocze)</i></p>",
    },
    {
      status: "Przetwarzanie zwrotu",
      desc: "<p>Twój produkt został zweryfikowany, a my przetwarzamy Twój zwrot w wysokości<span style='{showAmount}'> <strong>{RefundAmtActual}</strong> USD</span>.</p><p><i>(Zwykle zajmuje to 3-5 dni robocze)</i></p>",
    },
    {
      status: "Zwrot zakończony",
      desc: "<p>Zrealizowaliśmy zwrot na konto, z którego opłacono zakup produktu. Przetworzenie wniosku może potrwać do 30 dni. Skontaktuj się ze swoim bankiem w celu uzyskania dalszych informacji.</p><p><i>(Może potrwać do 30 dni, zanim bank przetworzy otrzymanie zwrotu pieniędzy)</i></p>",
    }
  ],
  'what-are-reason': 'Jaki jest powód zwrotu powrotu?',
  'which-part-defective': 'Który element produktu jest wadliwy?',
  'please-select-one': 'Proszę wybrać jeden.',
  'cosmetic-damages': 'Czy są jakieś fizyczne / Wada kosmetyczna uszkodzenia produktu?',
  'attach-photo': 'Załącz zdjęcie szkody:',
  'comments': 'Komentarze',
  'enter-comments': '	Wprowadź szczegółowy opis zapytania.',
  'rma-exists': 'Dla tego produktu przesłano prośbę RMA.',
  'rma-created': 'Żądanie RMA już istnieje dla tego produktu i nie można go utworzyć ponownie.',
  'rma-cancelled': 'Twoje zgłoszenie RMA zostało anulowane. Jeśli masz jakiekolwiek pytania dotyczące anulowania żądania RMA, skontaktuj się z nami.',
  'selected-maximum': 'Wybrano maksymalną dozwoloną ilość.',
  'shipping-information': 'Informacje dotyczące wysyłki',
  'shipping-address': 'Adres wysyłki',
  'select-shipping-address': 'Wybierz swój adres wysyłki.',
  'replace-sent-address': 'Zamiennik zostanie wysłany na następujący adres zwrotny.  ',
  'product-purchased-from': 'Produkt zakupiono za pośrednictwem',
  'creative-store': 'Sklep Creative',
  'all-other-retailers': 'Inny sprzedawca',
  'product-not-received': 'Nieotrzymany',
  'product-cancelled': 'Anulowany',
  'rma-closed': 'Zrealizowane',
  'select-mode-of-contact': 'Wybierz sposób kontaktu z nami.',
  'email-us': 'Wyślij nam wiadomość e-mail',
  'your-order': 'Twoje zamówienie',
  'refund-amount': 'Kwota zwrotu ',
  'shipping-charge': 'Opłata za wysyłkę',
  'store-credit': 'Rabat',
  'tax': 'Podatek',
  'deliver-unable-info':'Nie dostarczamy przesyłek do skrytek pocztowych, hoteli, moteli oraz na następujące terytoria zamorskie. <a href="/help/delivery#what-are-the-overseas-territories-that-you-don-39-t-deliver-to" target="_blank">Dowiedz się więcej</a>.',
  'creative-in-warranty': '',
  'extended-warranty': '',
  'maintenance-msg': `Uwaga: Sklep internetowy będzie przechodzić zaplanowaną konserwację, aby lepiej Ci służyć. Prace zaplanowane są na niedzielę, 09 października 2022 r., w godzinach 9:00 - 15:00 (GMT +8:00). W tym czasie nasze strony internetowe nie będą dostępne.
                      <br><br>
                      Przepraszamy za zaistniałe niedogodności i dziękujemy za cierpliwość.`,
  'shipping-country-notice-pl': 'Sklep realizuje zamówienia tylko na terenie Polski. Nie dostarczamy zamówień do skrzynek pocztowych, paczkomatów, stacji Packstation, hoteli, moteli itp. <a href="[store]/help/delivery#where-do-you-ship-to-" target="_blank">Dowiedź się więcej</a>.'
}